import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AgentVerificationApplicationsTable } from '../shared/agentVerificationApplicationsTable'

import { AgentVerificationApplicationRow } from '@percent/admin-dashboard/api/types'
import { useValidationSubmissionsAccess } from '@percent/admin-dashboard/common/hooks'
import { AgentVerificationDocumentComparisonModal } from './agentVerificationDocumentComparisonModal/AgentVerificationDocumentComparisonModal'
import { AgentVerificationMatchedDocumentsProps } from './AgentVerificationMatchedDocuments.types'

export function AgentVerificationMatchedDocuments({
  isLoadingMatchedDocuments,
  matchedDocuments,
  totalCount,
  thisApplication,
  thisApplicationDocuments
}: AgentVerificationMatchedDocumentsProps) {
  const { t } = useTranslation()
  const [selectedMatchIndex, setSelectedMatchIndex] = useState<number | null>(null)
  // The comparison modal reads submission documents on both sides of the comparison, so
  // it needs can_read_documents on the validation_submissions domain.
  const { canReadDocuments } = useValidationSubmissionsAccess()

  const openComparison = (application: AgentVerificationApplicationRow) => {
    const index = matchedDocuments?.findIndex(match => match.id === application.id) ?? -1

    if (index >= 0) {
      setSelectedMatchIndex(index)
    }
  }

  return (
    <>
      <AgentVerificationApplicationsTable
        applications={matchedDocuments}
        totalCount={totalCount}
        isLoading={isLoadingMatchedDocuments}
        showMatchType
        onViewDocument={canReadDocuments ? openComparison : undefined}
        heading={t('typography.matchedDocumentsHeading')}
        getInfoText={count => t('typography.matchedDocumentsInfo', { count })}
        emptyText={t('typography.noMatchedDocuments')}
        testId="agent-verification-matched-documents"
        emptyTestId="agent-verification-empty-matched-documents"
      />
      {selectedMatchIndex !== null && matchedDocuments && (
        <AgentVerificationDocumentComparisonModal
          onClose={() => setSelectedMatchIndex(null)}
          thisApplication={thisApplication}
          thisApplicationDocuments={thisApplicationDocuments}
          matches={matchedDocuments}
          initialMatchIndex={selectedMatchIndex}
        />
      )}
    </>
  )
}
